export default "__VITE_ASSET__d8e2184d__"